import {useRef, useState} from "react";
import PostList from '../../components/post_list';
import Main from '../../components/main';
import {FixedTopBar} from '../../components/top_bar';
import ErrorMessage from "../../components/error_message";
import {useSearch} from '../../api/feed';
import {useBottomBar} from "../../app_context";
import useFeedback from '../../utils/use_feedback';
import {useFeedState, useStoreProfile} from '../../store';
import {useQuery} from "../../utils/router";

const Search = () => {
    const {expand} = useStoreProfile();
    const {query, sort='new', community='win'} = useQuery();
    const {error, feedbackCh} = useFeedback();
    const signalRef = useRef(null);
    const key = `search/${query}:${community}:${sort}`;
    const feedState = useFeedState(key);
    const [restoredState, setRestoredState] = useState(feedState?.updatedTime > Date.now() - (15 * 60 * 1000) ? feedState : false);
    const {posts, more, loading, loadNextPage} = useSearch(feedbackCh, query, community, sort, signalRef, key, !restoredState);
    useBottomBar();
    return (
        <>
            <FixedTopBar back title="Search" />
            <Main>
                <ErrorMessage error={error}/>
                <PostList
                    expand={expand} posts={posts} loading={loading} loadNextPage={more && loadNextPage}
                    signalRef={signalRef} feedKey={key} restoredState={restoredState}
                />
            </Main>
        </>
    );
};

export default Search;
